/**
 * App Root — wires all providers and the router.
 * Provider order: I18n → Theme → Auth → Space → Router
 */
import { I18nProvider } from './providers/I18nProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { AuthProvider } from './providers/AuthProvider';
import { SpaceProvider } from './providers/SpaceProvider';
import { Router } from './Router';

export function App() {
  return (
    <I18nProvider>
      <ThemeProvider>
        <AuthProvider>
          <SpaceProvider>
            {/* Skip link for keyboard accessibility */}
            <a href="#main-content" className="skip-link">
              Skip to main content
            </a>
            <Router />
          </SpaceProvider>
        </AuthProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}
